import type { BoardData, BoardCell } from '../data/technique-boards';
import { useI18n } from '../i18n';
import './TechniqueBoard.css';

interface Props {
  data: BoardData;
}

export function TechniqueBoard({ data }: Props) {
  const { t } = useI18n();
  const rows = data.length;
  const cols = data[0]?.length ?? 0;
  const is9x9 = rows === 9 && cols === 9;

  const getCellClass = (cell: BoardCell | null, r: number, c: number) => {
    const cls = ['tb-cell'];
    if (!cell) {
      cls.push('tb-null');
    } else {
      cls.push(`tb-${cell.type ?? 'normal'}`);
    }
    if (is9x9) {
      if (c % 3 === 2 && c < 8) cls.push('tb-box-r');
      if (r % 3 === 2 && r < 8) cls.push('tb-box-b');
    }
    return cls.join(' ');
  };

  return (
    <div className="tb-wrap">
      <div className="tb-scroll">
        <table className="tb-table">
          <tbody>
            {data.map((row, r) => (
              <tr key={r}>
                {row.map((cell, c) => (
                  <td key={c} className={getCellClass(cell, r, c)}>
                    {cell?.v != null ? (
                      <span className="tb-val">{cell.v}</span>
                    ) : cell?.c && cell.c.length > 0 ? (
                      <div className="tb-cands">
                        {[1,2,3,4,5,6,7,8,9].map(n => {
                          const isElim = cell.xc?.includes(n);
                          const visible = cell.c!.includes(n);
                          return (
                            <span
                              key={n}
                              className={isElim ? 'tb-cx' : visible ? 'tb-cn' : 'tb-co'}
                            >
                              {visible ? n : ''}
                            </span>
                          );
                        })}
                      </div>
                    ) : null}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="tb-legend">
        <span className="tb-leg tb-leg-focus">{t.edu.boardLegendFocus}</span>
        <span className="tb-leg tb-leg-elim">{t.edu.boardLegendElim}</span>
        <span className="tb-leg tb-leg-result">{t.edu.boardLegendResult}</span>
        <span className="tb-leg tb-leg-cx">{t.edu.boardLegendCrossed}</span>
      </div>
    </div>
  );
}
